module.exports = __webpack_public_path__ + "static/media/danger-cross.0e8dab02.svg";